export default {
  getSearchInfo: '/search/api/v2/indexAll' // 搜索列表（依据各医院配置初始展示几条）
};
